import { useFormikContext } from 'formik'
import { useCallback } from 'react'
import { FieldsetCompletion } from 'types'
import { FormikErrors } from 'formik/dist/types'

export const useAutoCompleteFields = () => {
  const { setFieldValue } = useFormikContext()

  return useCallback((completedFields: FieldsetCompletion['completed_fields']) => {
    if (Object.keys(completedFields).length > 0) {
      const promises: Array<Promise<void | FormikErrors<any>>> = []
      Object.entries(completedFields).forEach(([key, value]) => {
        promises.push(setFieldValue(key, value, true))
      })
      return Promise.all(promises)
    }
    return Promise.resolve()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
}
